<script setup>

import {defineEmits, defineProps, nextTick, onMounted, ref} from "vue";
import CancelX from "@/components/icons/CancelX.vue";

const props = defineProps({
  classes: {
    type: String,
  },
  parentClasses: {
    type: String,
  },
  rounded: {
    type: Boolean,
    default: true
  },
  fullscreen: {
    type: Boolean,
    default: false
  },
  showInitially: {
    type: Boolean,
    default: false
  },
  initOnMount: {
    type: Boolean,
    default: false
  },

});

const isShown = ref(props.showInitially);

const emit = defineEmits(['hide']);


onMounted(() => {
  if (props.showInitially) {
    const backdrops = document.getElementsByClassName('dialog-backdrop-active');
    if (backdrops.length) {
      for (let i = 0; i < backdrops.length; i++) {
        if (i === 0) {
          continue;
        }
        backdrops.item(i).classList.remove('dialog-backdrop-active');
      }
    }
    stopRootScroll();
  }
});

const show = async () => {
  if (isShown.value) {
    return;
  }
  if (typeof window !== 'undefined') {
    await nextTick();
    hideActiveBackdrops();
    stopRootScroll();
  }
    isShown.value = true;
};

const hideActiveBackdrops = () => {
  const backdrops = document.getElementsByClassName('dialog-backdrop-active');
  if (backdrops.length) {
    for (let i = 0; i < backdrops.length; i++) {
      backdrops.item(i).classList.remove('dialog-backdrop-active');
    }
  }
};

const stopRootScroll = () => {
  const rootElements = document.querySelectorAll('html, body');
  for (const element of rootElements) {
    element.classList.add('dialog-shown');
  }
}

const hide = async () => {
  if (!isShown.value) {
    return;
  }
  emit('hide');
  isShown.value = false;
  if (typeof window !== 'undefined') {
    await nextTick();
    showLastBackdrop();
  }
};

const showLastBackdrop = () => {
  const backdrops = document.getElementsByClassName('dialog-backdrop');
  if (backdrops.length) {
    /** FOR SOME REASON DOCUMENTATION SAYS TELEPORT APPENDS ELEMENTS, BUT HERE IT PREPENDS... */
    backdrops.item(0).classList.add('dialog-backdrop-active');
    // backdrops.item(backdrops.length - 1).classList.add('dialog-backdrop-active');
    return;
  }
  const rootElements = document.querySelectorAll('html, body');
  for (const element of rootElements) {
    element.classList.remove('dialog-shown');
  }
};

defineExpose({
  show,
  hide
});
</script>

<template>
  <Teleport to="#dialogs">
    <div v-if="isShown || initOnMount" :class="{'dialog-backdrop dialog-backdrop-active' : isShown , 'd-none': initOnMount && !isShown}">
      <div class="dialog" :class="[parentClasses, {'fullscreen container-fluid container-md': fullscreen}]">
        <button type="button" class="btn inner-close-dialog" @click.stop="hide"><CancelX/></button>
        <div class="dialog-content" :class="[classes, {'rounded-4': rounded}]">
          <slot></slot>
        </div>
        <slot name="outer-bottom"></slot>
      </div>
    </div>
  </Teleport>
</template>